"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PlatformLogger = /** @class */ (function () {
    function PlatformLogger(_a) {
        var platformAPIs = _a.platformAPIs, biLoggerDefaultConfigurations = _a.biLoggerDefaultConfigurations, biLoggerEndPoint = _a.biLoggerEndPoint;
        this.logger = platformAPIs
            .biLoggerFactory()
            .updateDefaults(biLoggerDefaultConfigurations)
            .logger({
            endpoint: biLoggerEndPoint,
        });
    }
    PlatformLogger.prototype.log = function (data) {
        return this.logger.log(data);
    };
    return PlatformLogger;
}());
exports.PlatformLogger = PlatformLogger;
//# sourceMappingURL=platform-logger.js.map